// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Hcf1","image":"Header_image__qEg0D","name":"Header_name__3S0PB","info":"Header_info__UusDV","infoRow":"Header_infoRow__y06pJ"};